import { Injectable, Inject } from '@angular/core';
import { appDataServiceToken, AppDataService } from 'dashboard/services/app-data.service';
import { Resolve } from '@angular/router';
import { Observable, from } from 'rxjs';
import { NgxUserpilotService } from '@go-modules/services/userpilot/userpilot.service';
import dayjs from 'dayjs';

@Injectable({
	providedIn: 'root'
})
export class AppInitResolver implements Resolve<void> {
	constructor (
		@Inject(appDataServiceToken) private appDataService: AppDataService,
		private userpilotService: NgxUserpilotService
	) {}

	public resolve (): Observable<void> {
		return from(this.appDataService.initAppData().then(async () => {
			const user = this.appDataService.user ?? {};
			if (user.user_id == null) {
				return;
			}

			await this.userpilotService.identify(user.user_id, {
				user_id: String(user.user_id),
				app_surface: 'dashboard',
				provider_name: user.provider_name ?? user.auth_aliases?.[0]?.auth_provider?.provider_name,
				is_root_user: user.is_root_user === true,
				is_instructor: user.isInstructor === true || this.appDataService.hasInstructorRole(true),
				is_reviewer_plus: user.isReviewerPlus === true || this.appDataService.hasReviewerRole(true),
				is_presenter: user.isPresenter === true,
				created_at: dayjs(user.created).toISOString()
			});
		}));
	}
}
